import React from 'react';
import { ResetPasswordForm } from '../forms';
export const ResetPasswordContainer = ({ serverErrors, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ResetPasswordForm, { serverErrors: serverErrors })));
};
ResetPasswordContainer.defaultProps = {};
export default ResetPasswordContainer;
